import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {documentsService} from '@store/documents/documents.service';
import {DocumentsState} from '@store/documents/documents.store';

type SearchDocumentsParams = Partial<DocumentsState>

export const searchDocumentsEffect = createEffectFn((params$: Observable<SearchDocumentsParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => documentsService.getDocuments().pipe(catchError(() => EMPTY))),
  );
});
